import React from 'react'
import PropTypes from 'prop-types'

import TermsTableHeader from '../terms-table-header/TermsTableHeader'
import TermsTableItem from '../terms-table-item/TermsTableItem'

const TermsTable = ({ terms, selectedPayment, paymentFrequency, onClick }) => {
    if (!terms.length) return null

    return (
        <div className='pc-termsTable'>
            <TermsTableHeader />

            {terms.map((term) => {
                if (!Object.entries(term).length) return null

                return (
                    <TermsTableItem
                        key={term.term}
                        termItem={term}
                        selectedPayment={selectedPayment}
                        paymentFrequency={paymentFrequency}
                        onClick={onClick}
                    />
                )
            })}
        </div>
    )
}

TermsTable.propTypes = {
    terms: PropTypes.array,
    selectedPayment: PropTypes.object,
    onClick: PropTypes.func,
}

TermsTable.defaultProps = {
    terms: [],
    selectedPayment: {},
    onClick: () => {},
}

export default TermsTable
